import { useState } from 'react';
import styled from 'styled-components';
import { Flex } from '#atoms';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import Chip from './components/Chip';
import Normal from './components/Normal';
import OnePoint from './components/OnePoint';
import OT from './components/OT';

export function OnBoardCreateLecture() {
  const [type, setType] = useState<'normal' | 'ot' | 'onePoint'>('normal');
  return (
    <PrevHeaderBarWithTitleTemplate
      title="수업"
      hasBorder={false}
      ContainerStyle={{ position: 'relative' }}
      defaultBackground
      // rightContents={<SaveText disabled text="등록" />}
    >
      <Wrapper>
        <Label>
          수업 유형<Required>*</Required>
        </Label>
        <Chips gap={8}>
          <Chip
            title="정규"
            isSelected={type === 'normal'}
            onClick={() => setType('normal')}
          />
          <Chip
            title="체험"
            isSelected={type === 'ot'}
            onClick={() => setType('ot')}
          />
          <Chip
            title="원포인트"
            isSelected={type === 'onePoint'}
            onClick={() => setType('onePoint')}
          />
        </Chips>
        <div style={{ height: '40px' }} />
        {type === 'normal' && <Normal />}
        {type === 'ot' && <OT />}
        {type === 'onePoint' && <OnePoint />}
      </Wrapper>
    </PrevHeaderBarWithTitleTemplate>
  );
}

const Wrapper = styled.section`
  padding: 20px;
`;
const Label = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray25};
`;

const Required = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.brand300};
`;

const Chips = styled(Flex)`
  margin-top: 12px;
`;
